module.exports = __webpack_public_path__ + "img/project2_small.404dfcd2.webp";